import script from "./author.vue?vue&type=script&setup=true&lang=js"
export * from "./author.vue?vue&type=script&setup=true&lang=js"

import "./author.vue?vue&type=style&index=0&id=cc048a82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc048a82"]])

export default __exports__